<template>
  <div class="exc-product-page" v-cloak>
    <navbar></navbar>

    <!-- 轮播图 -->
    <van-swipe class="swiper-block" indicator-color="white">
      <van-swipe-item v-for="(item, index) in productInfo.pic_list" :key="index">
        <!-- <img class="swiper-img" :src="item" alt="" /> -->
        <van-image class="swiper-img" :src="item" @click="imagePreview(productInfo.pic_list,index)">
          <template v-slot:loading>
            <van-loading type="spinner" size="20" />
          </template>
        </van-image>
      </van-swipe-item>
    </van-swipe>

    <!-- 商品名 -->
    <div class="goods-info">
      <div class="goods-price">
        <div class="price">
          <span class="price-icon">¥</span>{{ productInfo.shop_price || 0 | numToCash  }}
          <span class="original-price">市场价¥{{ productInfo.market_price || 0 | numToCash  }}</span>
        </div>
        <div class="sold">已售{{ productInfo.sales_sum }}</div>
      </div>

      <div class="goods-desc-block">
        <div class="goods-name">
          <van-tag color="#ff5000" type="primary" size="medium">推荐</van-tag>
          {{ productInfo.brand_name }}
          {{ productInfo.goods_name }}
        </div>
        <!-- <div class="goods-desc">{{ productInfo.description }}</div> -->
      </div>
    </div>

    <!-- cell -->
    <div class="goods-cell" @click="onSku">
      <div class="cell-tips">参数</div>
      <div class="cell-center">{{skusItem.spec_value}}*1</div>
    </div>
    <!-- 所在省市 -->
    <div class="goods-cell" v-if="productInfo.province_name">
      <div class="cell-tips">所在地</div>
      <div class="cell-center">{{productInfo.province_name}}-{{productInfo.city_name}}</div>
    </div>

    <!-- <div class="goods-cell" @click="goExpressRule()"> -->
    <!-- <div class="goods-cell">
      <div class="cell-tips">配送</div>
      <div class="cell-center" v-if="Number(productInfo.express_price) > 0 "> {{ productInfo.express_price }}</div>
      <div class="cell-center" v-else>包邮 <span style=" font-size: 10px;">(部分地区)</span> </div>
    </div> -->

    <div class="goods-cell mb5" v-if="productInfo.province_name">
      <div class="cell-tips">所在地</div>
      <div class="cell-center-n"> {{ productInfo.province_name }}-{{ productInfo.city_name }} </div>
    </div>

    <!-- 图片详情 -->
    <div class="goods-title">-商/品/详/情-</div>

    <div class="center-b" v-html="productInfo.goods_content">

    </div>

    <!-- 底部按钮 多商品-->
    <div class="tow-btn">
      <div class="btn-l" @click="onOtherGoods">
        <van-icon name="https://qiniu.zdyxjx.com/minizdyxgo_icon.png" size="15px" />
        其他商品
      </div>

      <div class="btns" @click="onSku">立即兑换</div>

    </div>

    <van-popup v-model="isSku" position="bottom" closeable close-icon="close" :style="{ height: '80%' }">
      <div class="sku-block">
        <!-- 详情 -->
        <div class="sku-header">
          <div class="sku-img-block">
            <van-image class="sku-img" :src="skusItem.pic" @click="imagePreview([skusItem.pic],0)" />
          </div>
          <div class="sku-info">
            <div class="sku-price">¥{{ skusItem.shop_price }}</div>
            <div class="original-price">¥{{ skusItem.market_price }}</div>
            <div class="sku-desc" v-if="oneSku == 1&&skusItem.spec_value">{{ skusItem.spec_value }}</div>
            <div class="sku-desc" v-if="oneSku == 2&&skusItem.spec_value">{{ skusItem.spec_value }}</div>
          </div>
        </div>

        <div class="sku-center-block">
          <!-- 选择 -->
          <!-- <div class="sku-radio mt20 plr20" v-if="productInfo.specs&&productInfo.specs.length > 0">
            <div class="sku-radio-name">{{ productInfo.specs[0].spec_name }}</div>
            <div v-for="(ita, idxa) in productInfo.specs[0].spec_sub" :key="idxa" :class="['radio', colorIndex == idxa ? 'radio-active' : '']" @click="getColor(idxa, ita)">
              {{ ita.spec_value }}
            </div>
          </div>

          <div class="sku-radio mt20 plr20" v-if="productInfo.specs && productInfo.specs.length > 1">
            <div class="sku-radio-name">{{ productInfo.specs[1].spec_name }}</div>
            <div v-for="(itb, idxb) in productInfo.specs[1].spec_sub" :key="idxb" :class="['radio', specIndex == idxb ? 'radio-active' : '']" @click="getSpec(idxb, itb)">
              {{ itb.spec_value }}
            </div>
          </div> -->

           <!-- 单规格 -->
           <div class="sku-radio mt20 plr20" v-if="oneSku == 1&& productInfo.specs">
            <div class="sku-radio-name">{{ productInfo.specs[0].spec_name }}</div>
            <div v-for="(ita, idxa) in productInfo.specs[0].spec_sub" :key="idxa" :class="['one-df-sku radio ', colorIndex == idxa ? 'radio-active' : '']" @click="getColor(idxa, ita)">
              <van-image class="img" width="30" height="30" :src="ita.pic" />
              {{ ita.spec_value }}
            </div>
          </div>

          <!-- 多规格 -->
          <div class="sku-radio mt20 plr20" v-if="oneSku == 2&&productInfo.specs&&productInfo.specs.length > 0">
            <div class="sku-radio-name" v-show="productInfo.specs[0].spec_sub[0].spec_value != '默认'">{{ productInfo.specs[0].spec_name }}</div>
            <div v-show="ita.spec_value != '默认'" v-for="(ita, idxa) in productInfo.specs[0].spec_sub" :key="idxa" :class="['radio', colorIndex == idxa ? 'radio-active' : '']" @click="getColor(idxa, ita)">
              {{ ita.spec_value }}
            </div>
          </div>

          <div class="sku-radio mt20 plr20" v-if="oneSku == 2&&productInfo.specs && productInfo.specs.length > 1">
            <div class="sku-radio-name">{{ productInfo.specs[1].spec_name }}</div>
            <div v-for="(itb, idxb) in productInfo.specs[1].spec_sub" :key="idxb" :class="['radio', specIndex == idxb ? 'radio-active' : '']" @click="getSpec(idxb, itb)">
              {{ itb.spec_value }}
            </div>
          </div> 
          
          <div class="goods-num">
            <p class="num-title">数量 <span v-if="skusItem.stock > 0">库存{{skusItem.stock}}</span></p>
            <!-- :disabled="disabled" :max="skusItem.stock"-->
            <van-stepper v-model="amount" theme="round" disabled button-size="22" disable-input />
          </div>
        </div>

        <div class="sku-btn-block">
          <div class="sku-btn-left btnC" @click="goConfirmOrder()">立即兑换</div> 
        </div>
      </div>
    </van-popup>

    <!-- 弹出层 -->
    <van-popup v-model="isOtherGoods" position="bottom" closeable close-icon="close" :style="{ height: '80%', background: '#F9F9F9' }">
      <div class="other-title">
        <p>其他商品</p>
      </div>

      <div class="other-list">
        <div v-for="(item, index) in otherList" :key="index" class="other-goods-block">
          <div class="other-img" @click="getOtherGoods(item)">
            <img :src="item.pic" />
          </div>

          <!-- <div class="danger" v-if="item.quantity < 1">已售空</div> -->

          <div class="other-info-block" @click="getOtherGoods(item)">
            <div class="other-name">{{ item.goods_name }}</div>
            <!-- <div class="other-desc">{{ item.description }}</div> -->

            <div class="other-price-block">
              <div class="other-price-tips">市场价</div>
              <div class="other-price">￥{{ item.shop_price }}</div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>

  </div>
</template>

<script>
var mrSKU = [
  {
    spec_id: 0,
    spec_name: "规格",
    spec_sub: [
      {
        spec_value: "默认",
        spec_value_id: 0,
      },
    ],
  },
];
import { ImagePreview } from "vant";
import navbar from "@/components/navbar/navbar.vue";
export default {
  name: "GoodsDetails",
  components: { navbar },
  props: {},
  data() {
    return {
      productId: this.$route.query.goods_id,

      amount: 1, //商品数量步进器
      
      oneSku: 1, // 1 单规格  2 多规格 3 没有规格

      productInfo: {},
      isSku: false, //sku弹窗
      skusItem: {
        pic: "",
        sku_id: "", //商品skuid
        spec_value_ids: "", //商品规格值id，多个逗号隔开
        market_price: "", //市场价
        shop_price: "", //销售价
        stock: "", //库存
        spec_value: "", //规格值内容
      },
      colorIndex: 0,
      specIndex: 0,
      disabled: false,
      // 双规格时两个都赋值
      colorSku: "",
      specSku: "",

      isOtherGoods: false, //其他商品弹窗

      otherList: [
        // {
        //   costPrice: 100,
        //   description: "乐扣乐扣-莹彩蓝轻量保温杯",
        //   imageUrl: "http://qiniu.zdyxjx.com/product/upload_pic_1608275023065",
        //   name: "乐扣乐扣-莹彩蓝轻量保温杯",
        //   ordinal: 0,
        //   productId: "12131",
        //   quantity: 1000,
        //   salePrice: 0,
        //   showPrice: 100,
        //   state: 1,
        // },
      ], //其他商品
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.init();
    this.initOtherList();
  },
  methods: {
    imagePreview(list, index) {
      ImagePreview({
        //图片预览
        images: list, //需要预览的图片 URL 数组
        showIndex: true, //是否显示页码
        loop: false, //是否循环播放
        startPosition: index, //图片预览起始位置索引
        closeable: true, //是否显示关闭图标
        // showIndicators: true, //	是否显示轮播指示器
      });
    },
    initOtherList() {
      let _this = this;
      let data = {
        card_code: Lockr.get("card_code"),
        card_pwd: Lockr.get("card_pwd"),
      };

      this.$post("/api/exchange_goods_list", data, data).then((res) => {
        console.log(res.data);

        if (res.data.code == 0) {
          _this.otherList = res.data.data.goods_list;
        } else {
          this.$toast.fail(res.data.message);
          this.finished = true;
        }
      });
    },

    // 初始化商品详情数据
    init() {
      let _this = this;
      this.$toast.loading();
      let data = {
        goods_id: _this.productId,
        card_code: Lockr.get("card_code"),
        card_pwd: Lockr.get("card_pwd"),
      };
      _this.$post("/api/exchange_goods_detail", data, data).then((res) => {
        console.log(res.data);
        if (res.data && res.data.code == 0) {
          // console.log(res.data.data);
          _this.productInfo = res.data.data;

          _this.productInfo.goods_content = _this.formatRichText(
            res.data.data.goods_content
          );

          _this.isCollection = res.data.data.isCollected > 0 ? true : false;

          if (res.data.data.specCombs.length < 1) {
            _this.oneSku = 3; // 1 单规格  2 多规格 3 没有规格
            // 没有规格
            _this.productInfo.specCombs = [
              {
                pic: res.data.data.pic || "",
                market_price: res.data.data.market_price, // 市场价
                shop_price: res.data.data.shop_price, //销售价
                sku_id: 0,
                spec_value: "默认",
                spec_value_ids: 0,
                stock: res.data.data.stock, //库存
              },
            ];
            // console.log(mrSKU)
            _this.productInfo.specs = mrSKU;
            // _this.CombinedSku = res.data.data.specCombs[0].spec_value;
            // return;
          }

          if (_this.productInfo.specs.length > 1) {
            _this.oneSku = 2; // 1 单规格  2 多规格 3 没有规格
            _this.productInfo.specCombs.map((item, index) => {
              if (item.pic == "" || item.pic == undefined || item.pic == null) {
                item.pic = _this.productInfo.pic;
              }
            });
            //  双规格时两个都赋值
            _this.colorSku = _this.productInfo.specs[0].spec_sub[0].spec_value;
            _this.specSku = _this.productInfo.specs[1].spec_sub[0].spec_value;
          } else {
            // console.log(_this.productInfo)
            // console.log(_this.productInfo.specs)
            //  单规格
            _this.oneSku = 1; // 1 单规格  2 多规格 3 没有规格
             // 先往 单规格的sku里塞图片
             _this.productInfo.specs[0].spec_sub.map((item, index) => {
              _this.productInfo.specCombs.find((value, index, arr) => {
                if (value.spec_value == item.spec_value) {
                  // console.log("一样", item);
                  // console.log("二样", value);
                  value.pic = value.pic || _this.productInfo.pic;
                  item = Object.assign(item, {
                    pic: value.pic || _this.productInfo.pic,
                  });
                }
              });
            });

            _this.colorSku = _this.productInfo.specs[0].spec_sub[0].spec_value;
          }
          _this.skusItem = _this.productInfo.specCombs[0];
          _this.$toast.clear();
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },

    // 关闭SKU弹窗
    onSku() {
      this.isSku = !this.isSku;
    },

    getColor(ind, e) {
      // 颜色
      let _this = this;

      _this.colorIndex = ind;
      _this.colorSku = e.spec_value;

      // 判断单双规格
      if (_this.productInfo.specs.length > 1) {
        // 双
        this.getSkuCode(e.spec_value, this.specSku);
      } else {
        // 单
        this.getOneSkuCode(e.spec_value);
      }
    },
    getSpec(index, e) {
      // 规格
      console.log(index, e.spec_value, this.colorSku);
      let _this = this;
      _this.specIndex = index;
      _this.specSku = e.spec_value;

      this.getSkuCode(this.colorSku, e.spec_value);
    },
    // 单规格
    getOneSkuCode(e) {
      let _this = this;
      _this.productInfo.specCombs.map((item, index) => {
        if (item.spec_value == e) {
          _this.skusItem = item;
        }
      });
    },
    // 双规格
    getSkuCode(a, b) {
      let _this = this;
      let s = a + "," + b;
      let ss = b + "," + a;

      console.log(s, "1样");
      _this.productInfo.specCombs.map((item, index) => {
        if (item.spec_value == s || item.spec_value == ss) {
          console.log(s, item, "2样");
          _this.skusItem = item;
        }
      });
    },

    // 跳确认订单
    goConfirmOrder() {
      let _this = this; 
      let obj = Object.assign(
        {
          cart_id: "0",
          goods_name: _this.productInfo.goods_name, //商品名称
          activity_type: _this.productInfo.activity_type, // 类型；1普通 2礼券 3积分 4兑换
          express_price: _this.productInfo.express_price, // 快递费
          // pic: _this.productInfo.pic, // 主图片
          brand_name: _this.productInfo.brand_name, // 品牌名称
          province_name: _this.productInfo.province_name, // 所在省
          city_name: _this.productInfo.city_name, // 所在市
          goods_id: _this.productId,
          amount: _this.amount,
        },
        this.skusItem
      );
      // console.log(this.skusItem, 'this.skusItem')
      // console.log(obj);
      Lockr.set("goodsInfo", [obj]);
      this.$router.push({
        name: "exchange-confirm-order",
        query: {
          // productId: this.productId,
        },
      });
    },
    //选择其他商品
    getOtherGoods(e) {
      console.log(e);
      this.productId = e.id;
      this.init(); // 刷新数据
      this.onOtherGoods(); //关闭弹窗
    },
    // 关闭其他商品弹窗
    onOtherGoods() {
      this.isOtherGoods = !this.isOtherGoods;
    },

    formatRichText(html) {
      /*
       * 处理富文本里的图片宽度自适应
       * 1.去掉img标签里的style、width、height属性
       * 2.img标签添加style属性：max-width:100%;height:auto
       * 3.修改所有style里的width属性为max-width:100%
       * 4.去掉<br/>标签
       * @param html
       * @returns {void|string|*}
       */
      let newContent = html.replace(/<img[^>]*>/gi, function (match, capture) {
        match = match
          .replace(/style="[^"]+"/gi, "")
          .replace(/style='[^']+'/gi, "");
        match = match
          .replace(/width="[^"]+"/gi, "")
          .replace(/width='[^']+'/gi, "");
        match = match
          .replace(/height="[^"]+"/gi, "")
          .replace(/height='[^']+'/gi, "");
        // match = match
        //   .replace(/src="([^"]+)"/gi, 'src="http://xiche.yiro.top$1"')
        //   .replace(/src='([^']+)'/gi, 'src="http://xiche.yiro.top$1"');
        return match;
      });
      newContent = newContent.replace(
        /style="[^"]+"/gi,
        function (match, capture) {
          match = match
            .replace(/width:[^;]+;/gi, "max-width:100%;")
            .replace(/width:[^;]+;/gi, "max-width:100%;");
          return match;
        }
      );
      // newContent = newContent.replace(/<br[^>]*\/>/gi, '');
      newContent = newContent.replace(
        /\<img/gi,
        '<img style="max-width:100%;height:auto;display:inline-block;"'
      );

      //去除table的宽度
      newContent = newContent.replace(
        /<table[^>]*>/gi,
        function (match, capture) {
          return match.replace(/width=\"(.*)\"/gi, "");
        }
      );

      //去除text-indent
      newContent = newContent.replace(
        /style="[^"]+"/gi,
        function (match, capture) {
          match = match
            .replace(/text-indent:[^;]+;/gi, "text-indent:0")
            .replace(/text-indent:[^;]+;/gi, "text-indent:0");
          return match;
        }
      );

      return newContent;

      //
    },
  },
};
</script>
<style lang="scss">
// 轮播图 图标颜色
.exc-product-page {
  .van-swipe__indicators {
    .van-swipe__indicator--active {
      background-color: #ff5000 !important;
    }
  }
  .van-stepper {
    .van-stepper__minus {
      color: #ff5000 !important;
      border-color: #ff5000 !important;
    }
    .van-stepper__minus--disabled {
      color: #666666 !important;
      border-color: #666666 !important;
    }
    .van-stepper__plus {
      background-color: #ff5000 !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.mb5 {
  margin-bottom: 5px;
}
.mb15 {
  margin-bottom: 15px;
}
.exc-product-page {
  height: 100%;
  width: 100%;
  background-color: #f9f9f9;
}

.swiper-block {
  height: 324px;
  width: 100%;
  // background-color: palegoldenrod;
  .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
    background-color: #fff;

    .swiper-img {
      width: 100%;
      height: 100%;
    }
  }
}

.center-b {
  padding: 15px;
  font-size: 13px;
  text-align: left;
  p {
    text-indent: 2em;
  }
  img {
    display: block;
    width: 100%;
  }
}
//商品名
.goods-info {
  // min-height: 107px;
  width: 100%;
  padding: 0 15px 15px;
  margin-bottom: 5px;
  //   background-image: url("https://qiniu.zdyxjx.com/minizdyxgoods-bg.png");
  //   background-repeat: no-repeat;
  //   background-size: 100% 100%;
  //   background-position: 0 0;
  background-color: #ffffff;

  .goods-price {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 41px;
    color: #ff5000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .price-icon {
      font-size: 12px;
    }
    .original-price {
      text-decoration: line-through;
      font-size: 12px;
      color: #78849e;
      margin-left: 10px;
    }
    .sold {
      color: #707070;
      font-size: 12px;
    }
  }

  .goods-desc-block {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    // color: #eeeeee;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;

    .goods-name {
      color: #2a2e43;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 30px;
      letter-spacing: 1px;
      text-align: left;
      // display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
      // -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
      // overflow: hidden; /*超出的文本隐藏*/
      // text-overflow: ellipsis; /* 溢出用省略号*/
      // -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
    }
    .goods-desc {
      text-align: left;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 21px;
      color: #707070;
      // display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
      // -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
      // overflow: hidden; /*超出的文本隐藏*/
      // text-overflow: ellipsis; /* 溢出用省略号*/
      // -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
    }
  }
}

/* cell */
.mb10 {
  margin-bottom: 10px;
}
.goods-cell {
  min-height: 44px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
}

.cell-tips {
  width: 15%;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 20px;
  color: #999999;
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin-right: 50rpx; */
}

.cell-center {
  width: 80%;
  font-size: 15px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 25px;
  padding-right: 15px;
  color: #2a2e43;
  /* background-color: #fff; */
  display: flex;
  justify-content: start;
  align-items: center;
  background-image: url("https://qiniu.zdyxjx.com/minizdyxarrow.png");
  background-repeat: no-repeat;
  background-size: 5px 10px;
  background-position: 95% center;
  /* white-space: nowrap; */
  /*内容超宽后禁止换行显示*/
  /* overflow: hidden; */
  /*超出部分隐藏*/
  /* text-overflow: ellipsis; */
  /*文字超出部分以省略号显示*/
  border-bottom: 1px solid #eeeeee;
}
.cell-center-n {
  width: 80%;
  font-size: 15px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 25px;
  padding-right: 15px;
  color: #2a2e43;
  /* background-color: #fff; */
  display: flex;
  justify-content: start;
  align-items: center;
  /* white-space: nowrap; */
  /*内容超宽后禁止换行显示*/
  /* overflow: hidden; */
  /*超出部分隐藏*/
  /* text-overflow: ellipsis; */
  /*文字超出部分以省略号显示*/
  border-bottom: 1px solid #eeeeee;
}
/* 图片头 */
.goods-title {
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 15px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 25px;
  color: #78849e;
  letter-spacing: 2.5px;
}
// 详情图
.goods-img-d {
  /* background-color: #fff; */
  /* min-height: 500rpx; */
  padding: 0 5px 60px 0;
  box-sizing: border-box;
  width: 100%;
  .img-d {
    display: block;
    width: 100%;
    /* height: 100%; */
  }
}

.tow-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 48px;
  z-index: 100;
  background-color: #fff;
  border-top: 1px solid #f9f9f9;
  display: flex;
  align-items: center;
  justify-content: space-around;

  .btn-l {
    display: flex;
    align-items: center;
    flex-direction: column;
    font-size: 10px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 15px;
    color: #78849e;
  }
  .btns {
    width: 270px;
    height: 40px;
    background: #ff5000;
    opacity: 1;
    border-radius: 20px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 20px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

/* sku弹出框*/
.sku-block {
  height: 100%;
  /* padding: 20rpx 0; */
  min-height: 200px;
  position: relative;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  /* padding-bottom: 100rpx; */
  .sku-center-block {
    height: 340px;
    -webkit-overflow-scrolling: touch;
    overflow-x: hidden;
    overflow-y: scroll;
    -ms-overflow-style: none; /* IE */
    scrollbar-width: none; /* Firefox */
    padding: 0 0 100px 0;

    /* 单选 */
    .one-df-sku {
      display: inline-flex !important;
      align-items: center;
      justify-content: center;

      .img {
        margin-right: 10px;
      }
    }
    .sku-radio {
      /* background-color: papayawhip; */
      text-align: left;
      padding: 10px;
    }
    .sku-radio-name {
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 25px;
      color: #999999;
    }
    .radio {
      min-width: 35px;
      text-align: center;
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 25px;
      color: #666666;
      display: inline-block;
      padding: 1px 5px;
      background: #eeeeee;
      border-radius: 5px;
      margin: 5px 10px;
      border: 1px solid #eeeeee;
    }
    .radio-active {
      background: #fff;
      border: 1px solid #ff5000;
      color: #ff5000;
    }

    // 步进器
    .goods-num {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;
      .num-title {
        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 26px;
        color: #999999;
        letter-spacing: 1px;
        span {
          font-size: 12px;
        }
      }
    }
  }

  .sku-header {
    margin-top: 10px;
    height: 125px;
    /* background-color: paleturquoise; */
    display: flex;
    justify-content: start;
    align-items: flex-end;
    padding: 0 10px;
    box-shadow: 0px 2px 5px rgba(69, 79, 99, 0.06);
  }
  .sku-img-block {
    width: 125px;
    height: 125px;
    border-radius: 5px;
  }
  .sku-img {
    border-radius: 5px;
    width: 125px;
    height: 125px;
  }
  .sku-info {
    /* background-color: pink; */
    margin-left: 10px;
    .original-price {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 20px;
      color: #78849e;
      text-decoration: line-through;
    }
    .sku-price {
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 30px;
      color: #ff5000;
    }
    .sku-desc {
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 25px;
      color: #454f63;
    }
  }
  .sku-btn-block {
    position: absolute;
    bottom: 10px;
    left: 0;
    width: 100%;
    height: 47px;
    padding: 0 15px;
    background-color: #ffffff;
    border-top: 1px solid #f9f9f9;

    box-shadow: 0px -5px 5px rgba(69, 79, 99, 0.06);
    display: flex;
    align-items: center;
    justify-content: center;
    .sku-btn-left {
      width: 70%;
      height: 40px;
      background: #ff5000;
      opacity: 1;
      border-radius: 20px; 
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 20px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
    } 
  }
}

//
/* 其他商品 */
.other-title {
  position: absolute;
  top: 0;
  left: 0;
  height: 40px;
  padding: 5px 0;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: 2px;
  color: #454f63;
}
.other-title p {
  border-left: 3px solid #ff5000;
  padding-left: 5px;
}
.other-list {
  position: absolute;
  top: 40px;
  left: 0;
  width: 100%;
  height: 90%;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE */
  scrollbar-width: none; /* Firefox */
}
.other-goods-block {
  background-color: #fff;
  margin: 10px;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* background-color: papayawhip; */
  /* height: 250rpx; */
  position: relative;

  .danger {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    font-size: 18px;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.other-img {
  width: 160px;
  height: 160px;
  img {
    width: 100%;
    height: 100%;
  }
}

.other-info-block {
  /* padding: 20rpx; */
  /* background-color: palevioletred; */
  height: 100%;
  margin-left: 15px;
  width: 200px;
  text-align: left;
}

.other-name {
  width: 100%;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 30px;
  color: #454f63;
  display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
  -webkit-line-clamp: 3; /*显示的行数；如果要设置2行加...则设置为2*/
  overflow: hidden; /*超出的文本隐藏*/
  text-overflow: ellipsis; /* 溢出用省略号*/
  -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
}

.other-desc {
  width: 100%;
  font-size: 10px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 17px;
  color: #78849e;
  display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
  -webkit-line-clamp: 3; /*显示的行数；如果要设置2行加...则设置为2*/
  overflow: hidden; /*超出的文本隐藏*/
  text-overflow: ellipsis; /* 溢出用省略号*/
  -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
}

.other-price-block {
  margin-top: 25px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 30px;
  color: #78849e;
}

.other-price-tips {
  font-size: 10px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 17rpx;
  color: #cccccc;
}
.other-price {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 30rpx;
  color: #ff5000;
}

.h-nav-item {
  position: fixed;
  top: 10px;
  left: 10px;
  width: 30px;
  height: 30px;
  border-radius: 12px;
  font-size: 15px;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0.8;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #eee;
}
</style>
